





































































































































import Vue from 'vue'
import Utils from '@/utils/utils'

export interface DataType {
  organizationType: string
  eventType: string
}

export default Vue.extend({
  data(): DataType {
    return {
      organizationType: '',
      eventType: '',
    }
  },
  mounted() {
    this.organizationType = Utils.switchOrganization(this.$store.getters.organization, '学会', '組織')
    this.eventType = Utils.switchOrganization(this.$store.getters.organization, '学術集会', 'イベント')
  },
  methods: {
    logout() {
      try {
        this.$store.dispatch('logout')
      } catch (e) {
        /* empty statement */
      }
    },
    // eslint-disable-next-line @typescript-eslint/ban-types
    clickAction(action?: Function) {
      if (action !== undefined) {
        action.call(this)
      }
    },
  },
})
